import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Checkbox,
  Button,
  Input
} from 'semantic-ui-react'

const CardSupplyOrderQueueListUX = (props: any) => {
    return(
      <div
        id="CardSupplyOrderQueueList"
        style={{margin: "10px"}}>
        <div
          id="CardSupplyOrderQueueListUX-div-41"
          style={{display: "flex", alignItems: "center"}}>
          
          <div
            id="CardSupplyOrderQueueListUX-div-1"
            style={{fontWeight: "bold", fontSize: "large"}}>
            {props.languageUX === "en" ? "Medical order list" : "รายการใบสั่งเวชภัณฑ์"}
          </div>
          <label
            id="CardSupplyOrderQueueListUX-label-45"
            style={{margin: "0 1rem 0 2rem"}}>
            {props.languageUX === "en" ? "Barcode scan" : "สแกนบาร์โค้ด"}
          </label>
          <Input
            id="CardSupplyOrderQueueListUX-Input-46"
            loading={props.barcodeLoading}
            onChange={props.onChangeBarcode}
            onKeyDown={props.onKeyDownBarcode}
            placeholder="Prescription, Label"
            size="small"
            style={{width: "12rem"}}
            value={props.barcodeScan || ""}>
          </Input>
        </div>
        <div
          className="ui form"
          id="CardSupplyOrderQueueListUX-div-2"
          style={{display: "", alignItems: "center", margin: "10px 0px"}}>
          
          <FormGroup
            id="CardSupplyOrderQueueListUX-FormGroup-12"
            inline={true}>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-25"
              inline={true}
              style={{padding:0}}>
              <label
                id="CardSupplyOrderQueueListUX-label-31"
                style={{textAlign: "right", width: "100%", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-13"
              inline={true}
              style={{padding:0}}
              width={3}>
              <div
                id="CardSupplyOrderQueueListUX-div-19"
                style={{width: "100%"}}>
                {props.cardPatientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-26"
              inline={true}
              style={{minWidth: "max-content", padding:0}}>
              <label
                id="CardSupplyOrderQueueListUX-label-32">
                {props.languageUX === "en" ? "Division/Ward" : "แผนก/หอผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-14"
              inline={true}
              width={3}>
              <div
                id="CardSupplyOrderQueueListUX-div-20"
                style={{width: "100%"}}>
                {props.divisionSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-27"
              inline={true}
              style={{minWidth: "max-content", paddingLeft: "0.5em"}}>
              <label
                id="CardSupplyOrderQueueListUX-label-33">
                {props.languageUX === "en" ? "Order Status" : "สถานะการสั่งซื้อ"}
              </label>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-15"
              inline={true}
              width={6}>
              <div
                id="cd-supplyOrderStatus"
                style={{width: "100%"}}>
                {props.orderSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-37"
              style={{minWidth: "max-content", paddingLeft: "0.5em"}}>
              <label
                id="CardSupplyOrderQueueListUX-label-39">
                ประเภท
              </label>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-38"
              inline={true}
              width={4}>
              <div
                id="CardSupplyOrderQueueListUX-div-40"
                style={{ width: "100%" }}>
                {props.typeSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-16"
              inline={true}>
              <Checkbox
                checked={props.isOPD}
                id="chk-supplyOPD"
                label={props.languageUX === "en" ? "OPD" : "OPD"}
                onChange={props.onChangeOPD}
                style={{width: "100%"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-17"
              inline={true}>
              <Checkbox
                checked={props.isIPD}
                id="chk-supplyIPD"
                label={props.languageUX === "en" ? "IPD" : "IPD"}
                onClick={props.onChangeIPD}
                style={{width: "100%"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSupplyOrderQueueListUX-FormField-18"
              inline={true}
              style={{ padding: 0 }}>
              <Button
                color="blue"
                id="btn-filterSupply"
                loading={props.btnLoading}
                onClick={props.onFilter}>
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardSupplyOrderQueueListUX-div-34">
          
          <Table
            data={props.supplyOrderQueueList}
            getTrProps={props.getTrProps}
            headers="ประเภท,ผู้ป่วย,หน่วยงานขอเบิก,สั่ง,ตรวจ,จัด,จ่าย"
            id="tb-supplyOrderReqList"
            keys="type,patient,clinic,requested,printed,checked,delivered"
            minRows="10"
            showPagination={false}
            style={{height: "calc(100dvh - 19rem)"}}
            widths="^100,^150,^150,^110,^110,^110,^110">
          </Table>
        </div>
        <div
          id="CardSupplyOrderQueueListUX-div-35"
          style={{display: "flex", justifyContent: "flex-end", margin:"0.75rem 0.5rem 0"}}>
          
          <div
            id="CardSupplyOrderQueueListUX-div-36">
            {props.Pagination}
          </div>
        </div>
      </div>
    )
}


export default CardSupplyOrderQueueListUX

export const screenPropsDefault = {}

/* Date Time : Fri Jan 09 2026 17:05:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueList"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 11,
      "name": "Table",
      "parent": 34,
      "props": {
        "NoDataComponent": {
          "type": "value",
          "value": " "
        },
        "data": {
          "type": "code",
          "value": "props.supplyOrderQueueList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ประเภท,ผู้ป่วย,หน่วยงานขอเบิก,สั่ง,ตรวจ,จัด,จ่าย"
        },
        "id": {
          "type": "value",
          "value": "tb-supplyOrderReqList"
        },
        "keys": {
          "type": "value",
          "value": "type,patient,clinic,requested,printed,checked,delivered"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 19rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^100,^150,^150,^110,^110,^110,^110"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormGroup-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ padding: 0 }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardPatientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderSearchBox"
        },
        "id": {
          "type": "value",
          "value": "cd-supplyOrderStatus"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Checkbox",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isOPD"
        },
        "id": {
          "type": "value",
          "value": "chk-supplyOPD"
        },
        "label": {
          "type": "value",
          "value": "OPD",
          "valueEN": "OPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeOPD"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Checkbox",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isIPD"
        },
        "id": {
          "type": "value",
          "value": "chk-supplyIPD"
        },
        "label": {
          "type": "value",
          "value": "IPD",
          "valueEN": "IPD"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeIPD"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "btn-filterSupply"
        },
        "loading": {
          "type": "code",
          "value": "props.btnLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onFilter"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", padding:0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", paddingLeft: \"0.5em\"}"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\", minWidth: \"max-content\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก/หอผู้ป่วย",
          "valueEN": "Division/Ward"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-label-32"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการสั่งซื้อ",
          "valueEN": "Order Status"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-label-33"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-34"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", margin:\"0.75rem 0.5rem 0\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Pagination"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-37"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", paddingLeft: \"0.5em\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-label-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.typeSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการใบสั่งเวชภัณฑ์",
          "valueEN": "Medical order list"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"large\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "สแกนบาร์โค้ด",
          "valueEN": "Barcode scan"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-label-45"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 1rem 0 2rem\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Input",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderQueueListUX-Input-46"
        },
        "loading": {
          "type": "code",
          "value": "props.barcodeLoading"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeBarcode"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownBarcode"
        },
        "placeholder": {
          "type": "value",
          "value": "Prescription, Label"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"12rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.barcodeScan || \"\""
        }
      },
      "seq": 46,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSupplyOrderQueueListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
